import { LoadingSpinner } from "components/loaders";

export const MapRouteLoader = () => {
  return (
    <LoadingSpinner loading className="h-full w-full" label="Loading map..." />
  );
};

export default MapRouteLoader;
